<script setup lang="ts">
const props = defineProps({
  warpClassName: {
    type: String,
  },
  radius: {
    type: Boolean,
  },
})
defineEmits(['headClick', 'click'])
defineSlots<{
  default: (props?: any) => any
  title?: (props?: any) => any
  extra?: (props?: any) => any
  footer?: (props?: any) => any
}>()
// let titleRender = typeof title === 'function' ? title() : title;
// let extraRender = typeof extra === 'function' ? extra() : extra;
const cardWarp = props.warpClassName ? `card-warp ${props.warpClassName}` : 'card-warp'
</script>

<template>
  <div :class="`card ${radius ? 'card-radius' : ''}`" @click="$emit('click')">
    <div class="card-head" @click="$emit('headClick')">
      <div class="card-title">
        <slot name="title" />
      </div>
      <div class="card-extra">
        <slot name="extra" />
      </div>
    </div>
    <div :class="cardWarp">
      <slot />
    </div>
    <div v-if="$slots.footer" class="card-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<style lang="scss">
@import "./index.module.scss";
</style>
